let heroMp4File = $('#home-hero-mp4-file'),
    heroWebmFile = $('#home-hero-webm-file'),
    heroVideoContainer = $('#home-hero-video-container');

if (heroVideoContainer.length && $(window).width() > 768) {

    var heroVideoObject = document.createElement("video");

    $(heroVideoObject).addClass('hero-video');

    if (heroMp4File.length) {
        var sourceMP4 = document.createElement("source");
        sourceMP4.type = "video/mp4";
        sourceMP4.src = heroMp4File.val();
        heroVideoObject.appendChild(sourceMP4);
    }

    if (heroWebmFile.length) {
        var sourceWebM = document.createElement("source");
        sourceWebM.type = "video/webm";
        sourceWebM.src = heroWebmFile.val();
        heroVideoObject.appendChild(sourceWebM);
    }

    heroVideoObject.autoplay = true;
    heroVideoObject.muted = true;
    heroVideoObject.loop = true;
    heroVideoObject.load();

    var playPromise = heroVideoObject.play();

    if (playPromise !== undefined) {
        playPromise.then(function () {
            heroVideoContainer.removeClass('d-none');
            $('.hero-block.is-video').addClass('video-is-loaded');
            // Automatic playback started!
        }).catch(function (error) {
            // Automatic playback failed.
            // Show a UI element to let the user manually start playback.
        });
    }

    heroVideoContainer.append(heroVideoObject);
}